"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.fetchAddressFromCoordinates = exports.searchAddress = exports.US_PLACES_COMPONENT_FILTER = exports.buildPlacesComponentFilter = exports.US_PLACES_FALLBACK_REGION_CODE = exports.US_PLACES_REGION_CODES = void 0;
// Google Places identifies US territories by their own ISO 3166-1 codes, so a
// plain "us" restriction hides Guam, Puerto Rico and the rest. The legacy
// Autocomplete APIs cap restrictions at 5 codes — one short of US plus all five
// inhabited territories — so American Samoa is carried by US_PLACES_FALLBACK_REGION_CODE.
exports.US_PLACES_REGION_CODES = ["us", "pr", "gu", "vi", "mp"];
exports.US_PLACES_FALLBACK_REGION_CODE = "as";
const buildPlacesComponentFilter = (regionCodes) => regionCodes.map(code => `country:${code}`).join("|");
exports.buildPlacesComponentFilter = buildPlacesComponentFilter;
exports.US_PLACES_COMPONENT_FILTER = (0, exports.buildPlacesComponentFilter)(exports.US_PLACES_REGION_CODES);
const searchAddress = (address, googleMapAPIKey) => __awaiter(void 0, void 0, void 0, function* () {
    var _a;
    if (!googleMapAPIKey) {
        throw new Error("Google Maps API key is not configured");
    }
    if (!address || !address.trim()) {
        return [];
    }
    const url = `https://maps.googleapis.com/maps/api/geocode/json`;
    const params = new URLSearchParams({
        address: address.trim(),
        key: googleMapAPIKey,
    });
    try {
        const response = yield fetch(`${url}?${params}`);
        const data = yield response.json();
        if (data.status === "ZERO_RESULTS") {
            return [];
        }
        if (data.status !== "OK") {
            throw new Error(`Geocoding failed: ${data.status}${data.error_message ? ` - ${data.error_message}` : ""}`);
        }
        if (!((_a = data.results) === null || _a === void 0 ? void 0 : _a.length)) {
            return [];
        }
        return data.results.map(result => ({
            formattedAddress: result.formatted_address,
            placeId: result.place_id,
            location: {
                lat: result.geometry.location.lat,
                lng: result.geometry.location.lng,
            },
            parsedAddress: parseAddressComponents(result),
        }));
    }
    catch (error) {
        if (error instanceof Error) {
            throw error;
        }
        throw new Error("Failed to search for address");
    }
});
exports.searchAddress = searchAddress;
const fetchAddressFromCoordinates = (lat, lng, googleMapAPIKey) => __awaiter(void 0, void 0, void 0, function* () {
    var _a;
    if (!googleMapAPIKey) {
        throw new Error("Google Maps API key is not configured");
    }
    const url = `https://maps.googleapis.com/maps/api/geocode/json`;
    const params = new URLSearchParams({
        latlng: `${lat},${lng}`,
        key: googleMapAPIKey,
    });
    try {
        const response = yield fetch(`${url}?${params}`);
        const data = yield response.json();
        if (data.status !== "OK") {
            throw new Error(`Geocoding failed: ${data.status}${data.error_message ? ` - ${data.error_message}` : ""}`);
        }
        if (!((_a = data.results) === null || _a === void 0 ? void 0 : _a.length)) {
            throw new Error("No results found for the provided coordinates");
        }
        // Find the first result with street_address type for most complete address
        // If no street_address result exists, fall back to the first result with postal code
        // If still no result, use the first available result
        let result = data.results[0];
        let streetAddressResult = data.results.find(r => r.types.includes("street_address"));
        if (streetAddressResult) {
            result = streetAddressResult;
        }
        else {
            let resultWithPostalCode = data.results.find(r => r.address_components.some(component => component.types.includes("postal_code")));
            if (resultWithPostalCode) {
                result = resultWithPostalCode;
            }
        }
        return parseAddressComponents(result);
    }
    catch (error) {
        if (error instanceof Error) {
            throw error;
        }
        throw new Error("Failed to fetch address from coordinates");
    }
});
exports.fetchAddressFromCoordinates = fetchAddressFromCoordinates;
const parseAddressComponents = (result) => {
    const components = result.address_components;
    let subpremise = "";
    let streetNumber = "";
    let route = "";
    let city = "";
    let state = "";
    let country = "";
    let zipCode = "";
    components.forEach(component => {
        const types = component.types;
        // Sub primise
        if (types.includes("subpremise")) {
            subpremise = component.long_name;
        }
        // Street Number
        if (types.includes("street_number")) {
            streetNumber = component.long_name;
        }
        // Route (Street Name)
        if (types.includes("route")) {
            route = component.long_name;
        }
        // City (locality, sublocality, administrative_area_level_3)
        if (types.includes("locality") && !city) {
            city = component.long_name;
        }
        else if (types.includes("sublocality") && !city) {
            city = component.long_name;
        }
        else if (types.includes("administrative_area_level_3") && !city) {
            city = component.long_name;
        }
        // State/Province (administrative_area_level_1)
        if (types.includes("administrative_area_level_1")) {
            state = component.long_name;
        }
        // Country
        if (types.includes("country")) {
            country = component.long_name;
        }
        // Zip/Postal Code (postal_code)
        if (types.includes("postal_code")) {
            zipCode = component.long_name;
        }
    });
    return {
        subpremise,
        streetNumber,
        route,
        city,
        state,
        country,
        zipCode,
    };
};
